import {Button} from '@/components/ui/button/Button'
import {ComboboxItem, ComboboxPopover} from '@/components/ui/combobox-atoms/ComboboxAtoms'
import {SelectComboboxList} from '@/components/ui/select-atoms/SelectAtoms'
import styled, {css} from 'styled-components'

export const StyledSearchSpecialistPopover = styled(ComboboxPopover)`
    padding: 0;
    gap: 0;
    z-index: 1;
`

export const StyledSelectSpecialistList = styled(SelectComboboxList)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 2}px;
    `
)

export const StyledSpecialistComboboxItem = styled(ComboboxItem)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 1.5}px;
    `
)

export const StyledAddSpecialistButton = styled(Button)(
    ({theme: {spacing}}) => css`
        width: fit-content;
        padding: ${spacing * 1.5}px ${spacing * 3}px;
        gap: ${spacing * 1.5}px;
        height: 40px;
        & > svg {
            width: 15px;
            height: 15px;
        }
    `
)
